// BuildingStabilityInfoComponent.js
import { useRef, useState } from "react";
import { SectionHeader } from "components";
import { Document } from "assets/icons"; // Replace with appropriate icons

import { UnitDTO } from "shared/types/unit";
import ModalUploadFileLog, { FileUploadField } from "shared/components/uploadFileModal/uploadFileModal";
import FileLogTable from "shared/components/uploadFileModal/fileLogTable";

interface BuildingDangerousMaterialsInfoComponentProps {
  handleCloseParent?: () => any;
  unit: UnitDTO;
}

const UnitDangerousMaterialsInfoComponent = ({
  handleCloseParent,
  unit,
}: BuildingDangerousMaterialsInfoComponentProps) => {
  const fileLogTableRef = useRef<{ saveChanges: () => Promise<void>; hasUnsavedChanges: boolean } | null>(null);
  const [fileModalOpen, setFileModalOpen] = useState<boolean>(false);

  return (
    <section className="flex flex-col gap-0 rounded-md bg-white">
      <SectionHeader
        title="Gevaarlijkes Stoffen Informatie"
        icon={<Document />}
        sticky={false}
        editMode={false}
        showEditToggle={true}
        onCloseClick={handleCloseParent}
        hideCloseAction={true}
      />
      <div className="p-3">
        <div className="flex flex-col gap-2">
          <FileLogTable
            ref={fileLogTableRef}
            acceptedLabels={["Asbestattest unit" as any]}
            onUploadClick={() => setFileModalOpen(true)}
            building={unit.building || undefined}
            unit={unit || undefined}
          />
        </div>
      </div>
      {/* Modal for File Upload */}
      <ModalUploadFileLog
        isOpen={fileModalOpen}
        onClose={() => setFileModalOpen(false)}
        building={unit.building || undefined}
        unit={unit || undefined}
        skipFields={[FileUploadField.BUILDING]}
        defaultFileLabel={"Asbestattest unit" as any}
        customLabels={["Asbestattest unit" as any]}
      />
    </section>
  );
};

export default UnitDangerousMaterialsInfoComponent;
